import { connect } from 'react-redux';

import {
  changeRevenueView,
  setRevenueColumnChartSorting,
  toggleRevenueAdaptive,
  toggleRevenueAverageLine,
  toggleRevenueCalcTotal,
  toggleRevenueMedianLine,
  toggleRevenueTrendLine,
} from '../../actions/revenue';
import { getRevenueChartOptions } from '../../reducers/analyticsApp';
import ExecutionOptionsBar from '../../components/common/ExecutionOptionsBar';
import {
  changeAdaptive,
  onChangeSorting,
  toggleAverage,
  toggleGrandTotal,
  toggleMedian,
  toggleTrend,
} from '../../actions/chart';

const mapStateToProps = (state) => ({
  options: getRevenueChartOptions(state),
  selectStyle: { width: 165 },
});

const mapDispatchToProps = (dispatch) => ({
  onChangeView: (view) => dispatch(changeRevenueView(view)),

  onChangeSorting: (sorting) =>
    onChangeSorting(sorting, () => dispatch(setRevenueColumnChartSorting(sorting))),
  toggleGrandTotal: (e, columnChartSorting) =>
    toggleGrandTotal(e, columnChartSorting, () => dispatch(toggleRevenueCalcTotal())),
  toggleTrendLine: (e) => toggleTrend(e, () => dispatch(toggleRevenueTrendLine())),
  toggleAverageLine: (e) => toggleAverage(e, () => dispatch(toggleRevenueAverageLine())),
  toggleMedianLine: (e) => toggleMedian(e, () => dispatch(toggleRevenueMedianLine())),
  toggleAdaptive: (e) => changeAdaptive(e, () => dispatch(toggleRevenueAdaptive())),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExecutionOptionsBar);
